import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import katex from 'katex';

@Component({
  selector: 'render-math',
  templateUrl: './render-math.component.html',
  styleUrls: ['./render-math.component.scss']
})
export class RenderMathComponent implements OnInit, OnDestroy {

  @Input() obj:any;
  @Input() prop:string;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() raw:string;
  @ViewChild('mathField') mathFieldRef: ElementRef;

  mathField:HTMLSpanElement;
  currentLatex;
  intervalTracker;
  isRendered:boolean;

  constructor() { }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.clearListener();  
  }

  clearListener(){
    if (this.intervalTracker){
      clearInterval(this.intervalTracker);
    }
  }

  ngAfterViewInit() {
    this.mathField = this.mathFieldRef.nativeElement;
    this.updateLatex();
    if (!this.raw){
      this.intervalTracker = setInterval(this.updateLatex.bind(this), 500);
    }
  }

  updateLatex(isForcedChange:boolean=false){
    if (this.isRendered){
      this.clearListener(); 
      return 
    }
    // console.log('updateLatex', this.raw, this.mathField)
    if (this.raw && this.mathField){
      katex.render(this.raw, this.mathField, {
        throwOnError: false
      });
      this.isRendered = true;
      return;
    }
    else if (this.mathField && this.obj && this.obj[this.prop]){
      if ( isForcedChange || (this.obj[this.prop] !== this.currentLatex) ){
        this.currentLatex = this.obj[this.prop];
        // this.mathField.innerHTML = '$$'+this.currentLatex+'$$';
        // this.MathLive.renderMathInElement(this.mathField);
        katex.render(this.currentLatex, this.mathField, {
          throwOnError: false
        });
        this.isRendered = true;
      }
  
    }
  }

}

